<template>
    <v-content>
        <v-row align="center" justify="center">
            <v-col class="display-1">
                Создание шаблона звонка
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="info" depressed @click="back()">
                        Назад
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-text-field
                    v-model="name"
                    placeholder="Название аудиозаписи"
                ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-select
                    v-model="source"
                    :items="sources"
                    item-text="name"
                    item-value="type"
                    label="Источник аудиоролика"
                    persistent-hint
                ></v-select>
            </v-col>
            <v-col cols="6" v-if="source === 'text'">
                <v-switch
                    v-model="gender"
                    true-value="1"
                    false-value="0"
                    :label="gender===0 ? 'Женский голос' : 'Мужской голос'"
                ></v-switch>
                <v-textarea
                    outlined
                    v-model="text_for_generation"
                ></v-textarea>
            </v-col>
            <v-col cols="6" v-if="source === 'file'">
                <v-file-input
                    accept=".wav"
                    label="Аудио файл формата .wav"
                    @change="handleFileSelect($event)"
                    v-model="file_for_sending"
                ></v-file-input>
                <audio v-if="!!file" controls :src="file"></audio>
            </v-col>
            <v-col cols="6">
                <p class="text-field-header">Аккаунт</p>
                <b-field>
                    <b-autocomplete
                      :value="mailing_account.name"
                      clearable
                      :data="filteredMailingAccounts"
                      :keep-first="false"
                      :open-on-focus="true"
                      field="name"
                      @input="option => onMailingAccountInput(option)"
                      @select="option => setMailingAccount(option)">
                      <template #empty> Нет результатов </template>
                    </b-autocomplete>
                </b-field>
            </v-col>
        </v-row>
        <v-col>
            <div class="float-right">
                <v-btn color="primary" depressed @click="createRecord()">
                    <v-icon small>mdi-plus</v-icon>
                    Сохранить
                </v-btn>
            </div>
        </v-col>
    </v-content>
</template>

<script>
export default {
    name: "audio",
    data() {
        return {
            source: null,
            sources: [
                {
                    name: 'Файл',
                    type: 'file'
                },
                {
                    name: 'Текст',
                    type: 'text'
                },
            ],
            mailing_account: {
                name: '',
            },
            name: '',
            text_for_generation: '',
            gender: 0,
            file: null,
            file_for_sending: null,
        };
    },
    created() {
        this.$store.dispatch('GET_MAILING_ACCOUNT_LIST', { type_of_notification: 'call' });
    },
    computed: {
        mailing_accounts() {
            return (this.$store.getters.MAILING_ACCOUNTS_LIST.results || []);
        },
        filteredMailingAccounts() {
            return this.mailing_accounts.filter(
              (t) =>
                t.name.toLowerCase().includes(
                  this.mailing_account.name.toLowerCase()
                )
            );
        },
    },
    methods: {
        createRecord() {
            var data = {};
            switch (this.source) {
                case 'file':
                    data = {
                        name: this.name,
                        source: this.source,
                        file: this.file_for_sending,
                        mailing_account_id: this.mailing_account.id,
                    };
                    break;
                case 'text':
                    data = {
                        name: this.name,
                        source: this.source,
                        text: this.text_for_generation,
                        gender: this.gender,
                        mailing_account_id: this.mailing_account.id,
                    };
                    break;

                default:
                    break;
            }

            if (data.hasOwnProperty("text") || data.hasOwnProperty("file")) {
                this.$store.dispatch('CREATE_RECORD', data)
                .then(() => {
                    this.$toaster.success('Запись создана');
                    this.back();
                })
                .catch(() => {
                    this.$toaster.error('Неизвестная ошибка!');
                });
            }

        },
        back() {
            this.$router.push({ path: "/audio-list" });
        },
        handleFileSelect(file) {
            if (file) {
                var reader = new FileReader();
                var _this = this;
                reader.onload = function(readerEvt) {
                    _this.file = 'data:audio/mpeg;base64,'+ btoa(readerEvt.target.result);
                }
                reader.readAsBinaryString(file);
            }
        },
        setMailingAccount(option) {
            if (option) {
              this.mailing_account = option;
            } else {
              this.mailing_account = { name: '' }; // или пустой объект {}
            }
        },
        onMailingAccountInput(value) {
            if (!value) {
              // обнуляем весь объект при очистке
              this.mailing_account = { name: '' };
            } else {
              // если нужно оставить ввод в поле
              this.mailing_account.name = value;
            }
        },
    },
};
</script>

<style></style>
